import { Alert, AlertDescription, AlertIcon, Box, Button, Divider, Flex, HStack, Link } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import config from '@common/config';
import { useDeviceDetection } from '@common/hooks/useDeviceDetection';
import React from 'react';
import { Link as RRDLink } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';
import { UI } from 'src/apps/invest/signup/views/components/UI';
import { useSignUpModel } from '../../models/SignUpModel';
import { PageHeader } from '../components/PageHeader';

export const SignUpSuccessPage: React.FC = () => {
  const { isDesktop } = useDeviceDetection();
  const singUpModel = useSignUpModel();
  const partner = singUpModel.partner?.name;

  return (
    <UI>
      <Flex px={[6, 20]} pt={[10, 20]} direction={'column'} gap={10} align="center">
        {partner && partner.length > 0 ? (
          <>
            <Alert status="success">
              <AlertIcon />
              <AlertDescription>
                We've found special perks for you for coming through <strong>{partner}</strong>! Let's get your account
                wrapped up.
              </AlertDescription>
            </Alert>
            <PageHeader
              title="Complete your profile"
              subtitle="We need more information to setup your account.  Please be sure to complete this here on our beta web app before using our mobile app. You can then sign into our mobile app as well for our flagship products and experience."
            />
            <Box textAlign={'center'} p="20px">
              <Button as={RRDLink} to={ROUTES.createCitizenship} size="lg" variant={'solid'}>
                Create Investor Profile Now
              </Button>
            </Box>{' '}
          </>
        ) : (
          <>
            <PageHeader
              title="Let's get your profile created with our mobile app."
              subtitle={
                isDesktop &&
                'Scan the QR code below to download our mobile app, or click on one of the links below. You can complete your account profile creation and start your portfolio here for our flagship products.'
              }
            />
            {isDesktop && (
              <Box>
                <Image image="store-qr-code" boxSize={130} />
              </Box>
            )}
            <HStack>
              <Link href={config.ADJUST_STORE_LINK}>
                <Image image="store-badge-ios" width={200} />
              </Link>
              <Link href={config.ADJUST_STORE_LINK}>
                <Image image="store-badge-android" width={200} />
              </Link>
            </HStack>
            <Divider />
            <PageHeader
              title="Want to try out our beta web experience?"
              subtitle={
                isDesktop &&
                'Feel free to complete your profile setup with our new web experience. This product is in an early stage of its life and may not have the same features as the mobile app.'
              }
            />
            <Box textAlign={'center'} p="20px">
              <Button as={RRDLink} to={ROUTES.createCitizenship} size="lg" variant={'solid'}>
                Create Investor Profile Now
              </Button>
            </Box>
          </>
        )}
      </Flex>
    </UI>
  );
};
